module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/halloween_img_instagram.e65aabb9.png";